module.exports = __webpack_public_path__ + "media/images/device-tablet-icon-7a8a9a882f5bd0608b8991a0fd3daa4c.svg";